import {useMemo} from "react";

import {uniq} from "@pg-mono/nodash";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {getStorageSentApplicationsIdListByOffer} from "../../utils/multi_lead/get_storage_sent_applications_id_list_by_offer";
import {IUseRecommendationsOfferProps, IUseRecommendationsPropertyProps, useRecommendations} from "./use_application_multi_lead_recommendation_list";

interface IProps {
    offer?: {
        id: IOfferDetailApplication["id"];
        geo_point: Pick<IOfferDetailApplication["geo_point"], "coordinates">;
        region: Pick<IOfferDetailApplication["region"], "country" | "parent">;
    };
    property?: Pick<IPropertyDetailApplication, "id">;
    distanceInKm: number;
    maxPrice?: number;
    skip?: boolean;
    offersToExclude?: number[];
}

export function useRecommendationsExcludingSentApplications(params: IProps) {
    const {offer, property, skip, maxPrice, distanceInKm, offersToExclude = []} = params;

    const excludedOfferIds = useMemo(() => {
        return uniq(
            getStorageSentApplicationsIdListByOffer(offer, {
                limit: 50,
                distance: DEFAULT_FILTER_RADIUS * 1000
            }).concat(offersToExclude)
        );
    }, [offer]);

    const filters = useMemo(() => {
        return {
            ...(maxPrice ? {max_price: maxPrice.toString()} : {}),
            radius: distanceInKm.toString() || DEFAULT_FILTER_RADIUS.toString()
        };
    }, [maxPrice, distanceInKm]);

    return useRecommendations(
        property?.id
            ? ({
                  offerId: offer?.id,
                  propertyId: property.id,
                  excludedOfferIds,
                  filters,
                  skip
              } as IUseRecommendationsPropertyProps)
            : ({
                  offerId: offer?.id,
                  excludedOfferIds,
                  skip
              } as IUseRecommendationsOfferProps)
    );
}

const DEFAULT_FILTER_RADIUS = recommendationsDistanceInKm;
import {useMemo} from "react";

import {uniq} from "@pg-mono/nodash";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {getStorageSentApplicationsIdListByOffer} from "../../utils/multi_lead/get_storage_sent_applications_id_list_by_offer";
import {IUseRecommendationsOfferProps, IUseRecommendationsPropertyProps, useRecommendations} from "./use_application_multi_lead_recommendation_list";

interface IProps {
    offer?: {
        id: IOfferDetailApplication["id"];
        geo_point: Pick<IOfferDetailApplication["geo_point"], "coordinates">;
        region: Pick<IOfferDetailApplication["region"], "country" | "parent">;
    };
    property?: Pick<IPropertyDetailApplication, "id">;
    distanceInKm: number;
    maxPrice?: number;
    skip?: boolean;
    offersToExclude?: number[];
}

export function useRecommendationsExcludingSentApplications(params: IProps) {
    const {offer, property, skip, maxPrice, distanceInKm, offersToExclude = []} = params;

    const excludedOfferIds = useMemo(() => {
        return uniq(
            getStorageSentApplicationsIdListByOffer(offer, {
                limit: 50,
                distance: DEFAULT_FILTER_RADIUS * 1000
            }).concat(offersToExclude)
        );
    }, [offer]);

    const filters = useMemo(() => {
        return {
            ...(maxPrice ? {max_price: maxPrice.toString()} : {}),
            radius: distanceInKm.toString() || DEFAULT_FILTER_RADIUS.toString()
        };
    }, [maxPrice, distanceInKm]);

    return useRecommendations(
        property?.id
            ? ({
                  offerId: offer?.id,
                  propertyId: property.id,
                  excludedOfferIds,
                  filters,
                  skip
              } as IUseRecommendationsPropertyProps)
            : ({
                  offerId: offer?.id,
                  excludedOfferIds,
                  skip
              } as IUseRecommendationsOfferProps)
    );
}

const DEFAULT_FILTER_RADIUS = recommendationsDistanceInKm;
